import { ClaimRewardsOverviewPanel } from '../components/ClaimRewardsOverviewPanel'
import { ActionsViewState } from '@/features/actions/types'
import { ActionsView } from '@/features/actions/views/ActionsView'
import { MultiPanelDialog } from '@/features/dialogs/common/components/MultiPanelDialog'
import { Reward } from '@/features/topbar/types'
import { DialogTitle } from '@/ui/atoms/dialog/Dialog'

export interface ClaimRewardsViewProps {
  rewards: Reward[]
  actionsViewState: ActionsViewState
}

export function ClaimRewardsView({ rewards, actionsViewState }: ClaimRewardsViewProps) {
  return (
    <MultiPanelDialog>
      <DialogTitle>Claim rewards</DialogTitle>

      <ClaimRewardsOverviewPanel rewards={rewards} />

      <ActionsView state={actionsViewState} actionsGridLayout="compact" allowChangeWhenActionsInProgress={false} />
    </MultiPanelDialog>
  )
}
